<div class="flex flex-col gap-[17px]">
  <lib-perio-cheat-sheet-row [disabled]="isTopConfigDisabled()">
    <svg-icon characterKey key="px-16-perio-arrow-left" size="sm"></svg-icon>
    <svg-icon anotherCharacterKey key="px-16-perio-arrow-right" size="sm"></svg-icon>
    <span leadText> {{ 'perio_exam_cheat_sheet_move' | translate }}</span>
  </lib-perio-cheat-sheet-row>
  <lib-perio-cheat-sheet-row [disabled]="isTopConfigDisabled()">
    <span characterKey>{{ 'perio_exam_cheat_sheet_digit_key' | translate }}</span>
    <span leadText> {{ 'perio_exam_cheat_sheet_auto_advances' | translate }}</span>
  </lib-perio-cheat-sheet-row>
  <lib-perio-cheat-sheet-row [disabled]="isTopConfigDisabled()">
    <span characterKey>{{ 'perio_exam_cheat_sheet_bleeding_key' | translate }} </span>
    <span leadText> {{ 'perio_exam_cheat_sheet_bleeding' | translate }}</span>
  </lib-perio-cheat-sheet-row>
  <lib-perio-cheat-sheet-row [disabled]="isTopConfigDisabled()">
    <span characterKey>{{ 'perio_exam_cheat_sheet_suppuration_key' | translate }}</span>
    <span leadText> {{ 'perio_exam_cheat_sheet_suppuration' | translate }}</span>
  </lib-perio-cheat-sheet-row>
  <lib-perio-cheat-sheet-row [disabled]="isTopConfigDisabled()">
    <span characterKey>{{ 'perio_exam_cheat_sheet_recession_key' | translate }}</span>
    <span anotherCharacterKey>{{ 'perio_exam_cheat_sheet_digit_key' | translate }}</span>
    <span leadText> {{ 'perio_exam_cheat_sheet_recession' | translate }}</span>
  </lib-perio-cheat-sheet-row>

  <lib-perio-cheat-sheet-row class="mt-1">
    <span characterKey>{{ 'perio_exam_cheat_sheet_mobility_key' | translate }}</span>
    <span anotherCharacterKey>{{ 'perio_exam_cheat_sheet_mb_fg_digit_key' | translate }}</span>
    <span leadText> {{ 'perio_exam_cheat_sheet_mobility' | translate }}</span>
  </lib-perio-cheat-sheet-row>
  <lib-perio-cheat-sheet-row>
    <span characterKey>{{ 'perio_exam_cheat_sheet_furcuation_key' | translate }}</span>
    <span anotherCharacterKey>{{ 'perio_exam_cheat_sheet_mb_fg_digit_key' | translate }}</span>
    <span leadText> {{ 'perio_exam_cheat_sheet_furcuation' | translate }}</span>
  </lib-perio-cheat-sheet-row>

  <lib-perio-cheat-sheet-row class="mt-1" [disabled]="isBottomConfigDisabled()">
    <span characterKey>{{ 'perio_exam_cheat_sheet_digit_key' | translate }}</span>
    <span leadText> {{ 'perio_exam_cheat_sheet_auto_advances' | translate }}</span>
  </lib-perio-cheat-sheet-row>
  <lib-perio-cheat-sheet-row [disabled]="isBottomConfigDisabled()">
    <span characterKey>{{ 'perio_exam_cheat_sheet_bleeding_key' | translate }}</span>
    <span leadText> {{ 'perio_exam_cheat_sheet_bleeding' | translate }}</span>
  </lib-perio-cheat-sheet-row>
  <lib-perio-cheat-sheet-row [disabled]="isBottomConfigDisabled()">
    <span characterKey>{{ 'perio_exam_cheat_sheet_suppuration_key' | translate }}</span>
    <span leadText> {{ 'perio_exam_cheat_sheet_suppuration' | translate }}</span>
  </lib-perio-cheat-sheet-row>
  <lib-perio-cheat-sheet-row [disabled]="isBottomConfigDisabled()">
    <span characterKey>{{ 'perio_exam_cheat_sheet_recession_key' | translate }}</span>
    <span anotherCharacterKey>{{ 'perio_exam_cheat_sheet_digit_key' | translate }}</span>
    <span leadText> {{ 'perio_exam_cheat_sheet_recession' | translate }}</span>
  </lib-perio-cheat-sheet-row>
</div>
